module.exports = "/0e8d9e4c10ecc96ae93aaa2b69d940f1c8363bc3/0a802c4759154178410d9806072b1e8e.svg";